<template>
  <div>
  </div>
</template>

<script>
import { Navbar } from "src/components/UIComponents";
export default {
  name: "main-navbar",
  components: {
    Navbar
  }
};
</script>

<style scoped>
</style>
